import React, { Component } from 'react';
import './GenericTab.scss'
import Elements from '../../Elements';
import saveIcon from '../../../assets/icons/ic_save_white.png';
import crossIcon from '../../../assets/icons/ic_close_white.png';
import downloadIcon from '../../../assets/icons/ic_download_white.png';
import down_arrow from '../../../assets/icons/ic_expand_blue.png';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateCurrentGenericTabStatus, getGenericData, saveGenericData, downloadGenericData, blockUiFun, highlightSearchedResult } from '../../Redux/Actions/uiActions';
import { withRouter } from 'react-router';
import history from '../../Routers/history';
import { Link } from 'react-router-dom';
import TabDataDistributor from '../../Containers/TabDataDistributor';
import PopOverMenu from '../../Elements/Atoms/PopOverMenu';
import CreatePopMenu from '../../Elements/Molecules/CreatePopMenu';
import { Modal, ButtonV3 } from "react-ui-lib";

import DASHBOAARDBLACKICON from '../../../assets/icons/sideNavIcons/ic_dashboardBlack.png';
import TESTINGPAGEBLACKICON from '../../../assets/icons/sideNavIcons/ic_testingPageBlack.png';
import UISETTINGSBLACKICON from '../../../assets/icons/sideNavIcons/ic_uiSettingsBlack.png';
import MSGTEXTBLACKICON from '../../../assets/icons/sideNavIcons/ic_messageTextBlack.png';
import CARDSBLACKICON from '../../../assets/icons/sideNavIcons/ic_cardsBlack.png';
import IMAGESBLACKICON from '../../../assets/icons/sideNavIcons/ic_imagesBlack.png';
import FRAMEWORKSBLACKICON from '../../../assets/icons/sideNavIcons/ic_frameWorkBlack.png';
import JSBLACKICON from '../../../assets/icons/sideNavIcons/ic_jsBlack.png';
import CSSBLACKICON from '../../../assets/icons/sideNavIcons/ic_cssBlack.png';
import SETTINGSBLACKICON from '../../../assets/icons/sideNavIcons/ic_settingsBlack.png';
import { Button } from 'react-bootstrap';

class GenericTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            language: [
                { name: 'Arabic', code: 'ar' },
                { name: 'Cantonese', code: 'zh-yue' },
                { name: 'Dutch', code: 'nl' },
                { name: 'English', code: 'en' },
                { name: 'French', code: 'fr' },
                { name: 'German', code: 'de' },
                { name: 'Italian', code: 'it' },
                { name: 'Malay', code: 'ms' },
                { name: 'Mandarin', code: 'zh-cmn' },
                { name: 'Polish', code: 'pl' },
                { name: 'Portuguese', code: 'pt' },
                { name: 'Spanish', code: 'es' },
                { name: 'Swedish', code: 'sv' }
            ],
            genericTabListArray: [
                'Chatbot',
                'UI settings',
                'Message settings',
                'Cards',
                'Images',
                'Framework',
                'Custom JS',
                'Custom CSS',
                'Settings'
            ],
            currentTab : '',
            langSelector: false,
            slectedLangElm: { name: 'English', code: 'en' },
            blockGenericUi: false,
            isOpen: false,
            saveState: 'generic-Save',
            saveMessage: ''
        }
    }

    componentDidMount() {
        const isDeveloper = localStorage.getItem('dev_mode_secret') === 'SECRETDEVTOOLOPTIONSFORBOTFORGE';
        if(!isDeveloper) {
            // history.push('/');
            history.push('/bot-list');
        }
        if(!Object.keys(this.props.genericBotData).length) {
            this.props.blockUiFun(true);
            this.setState({blockGenericUi: true});
            this.props.getGenericData(this.props.currentLanguage || 'en', (res) => {
                // this.props.blockUiFun(false);
                this.setState({blockGenericUi: false});
            }, (err) => {
                console.log('err', err);
                this.props.blockUiFun(false);
                this.setState({blockGenericUi: false});
            })
        }
        this.selectedTab = this.props.location.pathname.split('/')[2];
        let tempArray = this.state.genericTabListArray.filter(elem => {
            return elem.toLowerCase().replace(/ /g,'').replace(/\//g,'') === this.selectedTab;
        });
        if(tempArray.length) {
            // const currentLangElm = ((elm) => {
            //     if(this.props.currentLangElm)
            // })
            // this.setState({blockGenericUi: true})
            // this.props.getGenericData(this.props.currentGenericLang, (res) => {
            //     console.log('res',res.data);
            //     this.setState({blockGenericUi: false})
            // }, (err) => {
            //     console.log('err', err);
            //     this.setState({blockGenericUi: false})
            // })
            let currentLangElm;
            if(this.props.currentGenericLang) {
                currentLangElm = this.state.language.filter(elm => elm.code === this.props.currentGenericLang);
            }
            this.setState({slectedLangElm: currentLangElm[0], blockGenericUi: false})
            this.props.updateCurrentGenericTabStatus(this.selectedTab);
        } else {
            alert('This is not a valid tab, moving to chatbot');
            history.push('/genericconfig/chatbot');
        }
    }

    addSelectEnvValue = () => {
        return (
            <span className = 'eb-icon-btn-image'>
                <Elements.Atoms.ImgTag
                    className = 'image'
                    src = {down_arrow}
                    alt = 'Close'
                />
            </span>
        );
    }
    
    UNSAFE_componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = (e) => {
        if(this.langnode && this.langnode.contains(e.target)) {
            const selectedLangCode = e.target.getAttribute('value');
            if(!selectedLangCode) return;
            const selectedLang = e.target.getAttribute('name');
            this.setState({slectedLangElm: {name: selectedLang, code: selectedLangCode}, langSelector: false, blockGenericUi: true});
            this.setState({blockGenericUi: true});
            this.props.blockUiFun(true);
            this.props.getGenericData(selectedLangCode, (res) => {
                // console.log('res',res);
                this.setState({blockGenericUi: false})
                this.props.blockUiFun(false);
            }, (err) => {
                console.log('err', err);
                this.setState({blockGenericUi: false})
                this.props.blockUiFun(false);
            })
            return;
        }
        if(this.langConatiner && this.langConatiner.contains(e.target)) {
            return;
        }

        this.setState({langSelector: false});
    }

    renderBotTabsTitle = (tabFromUrl) => {
        const langMenuClass = 'nav-item' + (this.state.langSelector ? ' open' : '')
        return (
            <>
            <div className={langMenuClass} key={11} ref = {langConatiner => this.langConatiner = langConatiner} onClick = {() => {
                this.setState({langSelector: !this.state.langSelector});
            }}>
                <div className = 'selector-btn' id = 'botForgeEnvironment' datatoggle = 'dropdown'>
                    <span className = 'selector-name'>{this.state.slectedLangElm.name}</span>
                    <div className = 'icon-button-wrapper go-float-right'>
                        <Elements.Atoms.Button
                            title ='Options'
                            className = 'eb-icon-btn-style'
                            type = 'button'
                            value = {this.addSelectEnvValue()}
                        />
                    </div>
                </div>
                <div className = 'dropdown-menu' aria-labelledby = 'botForgeBotId' ref = {langnode => this.langnode = langnode}>
                    {
                        this.state.language.map((elem, i) => {
                            if(JSON.stringify(elem) !== JSON.stringify(this.state.slectedLangElm)) {
                                return (
                                    <span className = 'dropdown-item' value = {elem.code} title = {elem.name} name = {elem.name} key = {i} >{elem.name}</span>
                                );
                            } else {
                                return null;
                            }
                        })
                    }
                </div>
            </div>
            {
                this.state.genericTabListArray.map((elem, i) => {
                    const elemInLowercase = elem.toLowerCase().replace(/ /g,'').replace(/\//g,'');
                    if(this.props.currentGenericActiveTab === elemInLowercase) {
                        return (
                            <li className='nav-item active' onClick={() => { this.props.updateCurrentGenericTabStatus(elemInLowercase) }} key={i}>
                                <Link className='nav-link' data-toggle='tab' to={`/genericconfig/${elemInLowercase}`} role='tab' aria-controls={elemInLowercase} aria-selected='true'>{elem}</Link>
                                <div className='underline'></div>
                            </li>
                        );
                    } else {
                        return (
                            <li className='nav-item' onClick={() => { this.props.updateCurrentGenericTabStatus(elemInLowercase) }} key={i}>
                                <Link className='nav-link' data-toggle='tab' to={`/genericconfig/${elemInLowercase}`} role='tab' aria-controls={elemInLowercase} aria-selected='false'>{elem}</Link>
                                <div className='underline'></div>
                            </li>
                        );
                    }
                })
            }
            </>
        );
    }

    getReadableName = (actualName) => {
        if(actualName) {
            const readableName = actualName.replace(/-|_|\//g, ' ');
            return readableName;
        }
    }

    inputUpdate = (e, element, parent) => {
        if(element.length) {
            let currentData = this.props.genericBotData;
            let value = e.target.value;
            if(typeof(currentData[parent][element]) === 'object') {
                currentData[parent][element][Object.keys(currentData[parent][element])[0]] = value;
            } else {
                currentData[parent][element] = value;
            }
            this.props.updateBotValue(currentData);
        } else {
            alert(`${element} can't be empty`);
        }
    }

    getConfDetails = (array) => {
        let tempConfString = '';
        for (let index = 0; index < array.length; index++) {
            tempConfString += array[index];
            if(index < (array.length - 1)) {
                tempConfString += ' > ';
            }        
        }
        return tempConfString;
    }

    addInputType = (parent,tempdata) => {
        if(!tempdata) return;
        const tempdataKeysArray = Object.keys(tempdata);
        return tempdataKeysArray.map((element, i) => {
            let containerClassName = 'character-input-box';
            if(tempdata[element].toString().length < 11) {
                containerClassName = 'character-input-box field-size-xs';
            } else if(tempdata[element].toString().length < 22) {
                containerClassName = 'character-input-box field-size-sm';
            } else if (tempdata[element].toString().length < 45) {
                containerClassName = 'character-input-box field-size-md';
            } else if (tempdata[element].toString().length < 70) {
                containerClassName = 'character-input-box field-size-lg';
            } else {
                containerClassName = 'character-input-box field-size-xl';
            }
            if(typeof(tempdata[element]) === 'object') {
                return(Object.keys(tempdata[element]).map ((elm, j) => {
                    const parentMatch = JSON.stringify([parent,element,elm]) === JSON.stringify(this.props.highlightSearchedData.parent);
                    const labelClassName = 'config-title' + (this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length && parentMatch ? ' highlighted' : '');
                    return (
                        <div className = 'config-input-block' key = {j}>
                            {parentMatch ? this.addTempDivToScroll() : null}
                            <div className = 'config-label'>
                                <label className = {labelClassName}>{this.getReadableName(elm)}</label>
                                <div className = 'more-options-btn-wrapper popover-inactive'>
                                    <PopOverMenu
                                        groupDesc = {'NA'}
                                        groupType={'group'}
                                        groupConfDetails = {this.getConfDetails([parent,element,elm])}
                                        groupTitle = {elm}
                                        tempdata={tempdata}
                                        parent = {[parent,element,elm]}
                                    />
                                </div>
                            </div>
                            <div className = 'config-input-area'>
                                <div className = {containerClassName} key = {i}>
                                    <input className = 'form-control character-input' type = 'text' placeholder = 'Type here...' autoComplete = 'off' defaultValue = {tempdata[element][Object.keys(tempdata[element])[j]]} onChange = {(e) => {
                                        this.inputUpdate(e, element, parent);
                                    }} onPaste = {(e) => {
                                        this.inputUpdate(e, element, parent);
                                    }}/>
                                </div>
                            </div>
                            {this.executeScroll()}
                        </div>
                    );
                })
                );
            } else {
                const parentMatch = JSON.stringify([parent,element]) === JSON.stringify(this.props.highlightSearchedData.parent);
                const labelClassName = 'config-title' + (this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length && parentMatch ? ' highlighted' : '');
                return (
                    <div className = 'config-input-block' key = {i}>
                        {parentMatch ? this.addTempDivToScroll() : null}
                        <div className = 'config-label'>
                            <label className = {labelClassName}>{this.getReadableName(element)}</label>
                            <div className = 'more-options-btn-wrapper popover-inactive'>
                                <PopOverMenu
                                    groupDesc = {'NA'}
                                    groupType={'group'}
                                    groupConfDetails = {this.getConfDetails([parent,element])}
                                    groupTitle = {element}
                                    tempdata={tempdata}
                                    parent = {[parent,element]}
                                />
                            </div>
                        </div>
                        <div className = 'config-input-area'>
                            <div className = {containerClassName} key = {i}>
                                <input className = 'form-control character-input' type = 'text' placeholder = 'Type here...' autoComplete = 'off' defaultValue = {tempdata[element]} onChange = {(e) => {
                                    this.inputUpdate(e, element, parent);
                                }} onPaste = {(e) => {
                                    this.inputUpdate(e, element, parent);
                                }}/>
                            </div>
                        </div>
                        {this.executeScroll()}
                    </div>
                );
            }
        });
    }

    addTempDivToScroll = () => {
        return (<div ref = {searchedNode => this.searchedNode = searchedNode}></div>)
    }

    scrollToRef = (ref) => {
        ref.scrollIntoView();
        // this.props.highlightSearchedResult({});
    }

    executeScroll = () => {
        setTimeout(() => {
            if(this.searchedNode)
            this.scrollToRef(this.searchedNode)
        },200)
    };

    loadGnericBodyTabs = () => {
        // let genericParentKeys = Object.keys(this.props.genericBotData);
        const { currentActiveTab } = this.props;
        let currentTab = 'chatbot'
        if(currentActiveTab) {
            if(currentActiveTab.split('/').length === 2) {
                currentTab = currentActiveTab.split('/')[2];
            } else {

            }
        }
        switch(this.props.currentGenericActiveTab) {
            case 'chatbot' :
                // return (
                //     <>
                //         <div className='tab-title-wrapper'>
                //             <div className='tab-title-icon-wrapper'>
                //                 <img src={DASHBOAARDBLACKICON} name='Dashboard' width='24px' height='24px' alt='Dashboard' />
                //             </div>
                //             <span className='tab-title-text' title='Dashboard'>{'Generic Config > Dashboard'}</span>
                //         </div>
                //         <div className = 'tab-pane fade active in show' id = 'dashboard' role = 'tabpanel' aria-labelledby = 'dashboard-tab'>
                //             <div className = 'tab-section-wrapper'>
                //                 <TabDataDistributor
                //                     tempdata = {{data: this.props.genericBotData.UI_OPTIONS.DASHBOARD, title: 'DASHBOARD', parentArray: ['DASHBOARD'], isGeneric: true}}
                //                 />
                //             </div>
                //         </div>
                //     </>
                // );
            case 'uisettings' :
                return (
                    <>
                        <div className='tab-title-wrapper'>
                            <div className='tab-title-icon-wrapper'>
                                <img src={UISETTINGSBLACKICON} name='UI Settings' width='24px' height='24px' alt='UI Settings' />
                            </div>
                            <span className='tab-title-text' title='UI Settings'>{'Generic Config > UI Settings'}</span>
                        </div>
                        <div className = 'tab-pane fade active in show'>
                            <TabDataDistributor
                                tempdata = {{data: this.props.genericBotData.UI_OPTIONS.USER_SIDE_SETTINGS, title: 'USER_SIDE_SETTINGS', parentArray: ['USER_SIDE_SETTINGS'], isGeneric: true}}
                            />

                            <div className="vertical-divider"></div>

                            <TabDataDistributor
                                tempdata = {{data: this.props.genericBotData.UI_OPTIONS.AGENT_SIDE_SETTINGS, title: 'AGENT_SIDE_SETTINGS', parentArray: ['AGENT_SIDE_SETTINGS'], isGeneric: true}}
                            />
                        </div>
                    </>
                );
            case 'messagesettings' :
                return (
                    <>
                        <div className='tab-title-wrapper'>
                            <div className='tab-title-icon-wrapper'>
                                <img src={MSGTEXTBLACKICON} name='MiscText' width='24px' height='24px' alt='Misc Text' />
                            </div>
                            <span className='tab-title-text' title='Misc Text'>{'Generic Config > Message Text'}</span>
                        </div>
                        <div className = 'tab-pane fade active in show'>
                            <TabDataDistributor
                                tempdata = {{data: this.props.genericBotData.UI_OPTIONS.MISC_TEXT, title: 'MISC_TEXT', parentArray: ['MISC_TEXT'], isGeneric: true}}
                            />
                        </div>
                    </>
                );
            case 'cards' :
                return (
                    <>
                        <div className='tab-title-wrapper'>
                            <div className='tab-title-icon-wrapper'>
                                <img src={CARDSBLACKICON} name='Cards' width='24px' height='24px' alt='Cards' />
                            </div>
                            <span className='tab-title-text' title='Cards'>{'Generic Config > Cards'}</span>
                        </div>
                        <div className = 'tab-pane fade active in show'>
                            <TabDataDistributor
                                tempdata = {{data: this.props.genericBotData.UI_OPTIONS.CARDS, title: 'CARDS', parentArray: ['CARDS'], isGeneric: true}}
                            />
                        </div>
                    </>
                );
            case 'images' :
                return (
                    <>
                        <div className='tab-title-wrapper'>
                            <div className='tab-title-icon-wrapper'>
                                <img src={IMAGESBLACKICON} name='Images' width='24px' height='24px' alt='Images' />
                            </div>
                            <span className='tab-title-text' title='Images'>{'Generic Config > Images'}</span>
                        </div>
                        <div className = 'tab-pane fade active in show'>
                            <TabDataDistributor
                                tempdata = {{data: this.props.genericBotData.UI_OPTIONS.MISC_IMAGES, title: 'MISC_IMAGES', parentArray: ['MISC_IMAGES'], isGeneric: true}}
                            />
                        </div>
                    </>
                );
            case 'framework' :
                return (
                    <>
                        <div className='tab-title-wrapper'>
                            <div className='tab-title-icon-wrapper'>
                                <img src={FRAMEWORKSBLACKICON} name='Framework' width='24px' height='24px' alt='Framework' />
                            </div>
                            <span className='tab-title-text' title='Framework'>{'Generic Config > Framework'}</span>
                        </div>
                        <div className = 'tab-pane fade active in show'>
                            <TabDataDistributor
                                tempdata = {{data: this.props.genericBotData.UI_OPTIONS.FRAMEWORKS, title: 'FRAMEWORKS', parentArray: ['FRAMEWORKS'], isGeneric: true}}
                            />
                        </div>
                    </>
                );
            case 'customjs' :
                return (
                    <>
                        <div className='tab-title-wrapper'>
                            <div className='tab-title-icon-wrapper'>
                                <img src={JSBLACKICON} name='CustomJS' width='24px' height='24px' alt='Custom JS' />
                            </div>
                            <span className='tab-title-text' title='Custom JS'>{'Generic Config > Custom JS'}</span>
                        </div>
                        <div className = 'tab-pane fade active in show'>
                            <TabDataDistributor
                                tempdata = {{data: this.props.genericBotData.UI_OPTIONS.CUSTOM_JS, title: 'CUSTOM_JS', parentArray: ['CUSTOM_JS'], isGeneric: true}}
                            />
                        </div>
                    </>
                );
            case 'customcss' :
                return (
                    <>
                        <div className='tab-title-wrapper'>
                            <div className='tab-title-icon-wrapper'>
                                <img src={CSSBLACKICON} name='CustomCSS' width='24px' height='24px' alt='Custom CSS' />
                            </div>
                            <span className='tab-title-text' title='Custom CSS'>{'Generic Config > Custom CSS'}</span>
                        </div>
                        <div className = 'tab-pane fade active in show'>
                            <TabDataDistributor
                                tempdata = {{data: this.props.genericBotData.UI_OPTIONS.CUSTOM_CSS, title: 'CUSTOM_CSS', parentArray: ['CUSTOM_CSS'], isGeneric: true}}
                            />
                        </div>
                    </>
                );
            case 'settings' :
                const postOptionsParentMatch = this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length === 1 && this.props.highlightSearchedData.parent['POST_OPTIONS'];
                const optionsParentMatch = this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length === 1 && this.props.highlightSearchedData.parent['OPTIONS'];
                const postOptionsClassName = 'config-title' + (postOptionsParentMatch ? ' highlighted' : '');
                const optionsClassName = 'config-title' + (optionsParentMatch ? ' highlighted' : '');
                return (
                    <>
                        <div className='tab-title-wrapper'>
                            <div className='tab-title-icon-wrapper'>
                                <img src={SETTINGSBLACKICON} name='Settings' width='24px' height='24px' alt='Settings' />
                            </div>
                            <span className='tab-title-text' title='Settings'>{'Generic Config > Settings'}</span>
                        </div>
                        <div className = 'tab-pane fade active in show'>
                            <TabDataDistributor
                                tempdata = {{data: this.props.genericBotData.SETTINGS, title: 'SETTINGS', parentArray: ['SETTINGS'], isGeneric: true}}
                            />

                            <div className="vertical-divider"></div>
                            
                            <div className = 'tab-section-wrapper'>
                                {postOptionsParentMatch ? this.addTempDivToScroll() : null}
                                <div className = 'container-fluid group-inputs-wrapper no-padding'>
                                    <div className = 'config-group-block' key = {0}>
                                        <div className = 'config-label'>
                                            <label className = {postOptionsClassName}>{this.getReadableName('POST_OPTIONS')}</label>
                                            <div className = 'more-options-btn-wrapper popover-inactive'>
                                                <PopOverMenu
                                                    groupDesc = {'NA'}
                                                    groupType={'group'}
                                                    groupConfDetails = {this.getConfDetails(['POST_OPTIONS'])}
                                                    groupTitle = {'POST_OPTIONS'}
                                                    tempdata={{data: this.props.genericBotData.SETTINGS, title: 'SETTINGS', parentArray: ['SETTINGS'], isGeneric: true}}
                                                    parent = {['POST_OPTIONS']}
                                                />
                                            </div>
                                        </div>
                                        <div className = 'config-group-area'>
                                            <div className = 'config-inputs-wrapper'>
                                                {this.addInputType('POST_OPTIONS',this.props.genericBotData.POST_OPTIONS)}
                                            </div>
                                            <div className = 'icon-button-wrapper go-float-right'>
                                                <CreatePopMenu 
                                                    className = 'eb-icon-btn-style add-new-input'
                                                    parentArray = {['POST_OPTIONS']}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="vertical-divider"></div>

                            <div className = 'tab-section-wrapper'>
                                {optionsParentMatch ? this.addTempDivToScroll() : null}
                                <div className = 'container-fluid group-inputs-wrapper no-padding'>
                                    <div className = 'config-group-block' key = {0}>
                                        <div className = 'config-label'>
                                            <label className = {optionsClassName}>{this.getReadableName('OPTIONS')}</label>
                                            <div className = 'more-options-btn-wrapper popover-inactive'>
                                                <PopOverMenu
                                                    groupDesc = {'NA'}
                                                    groupType={'group'}
                                                    groupConfDetails = {this.getConfDetails(['OPTIONS'])}
                                                    groupTitle = {'OPTIONS'}
                                                    tempdata={{data: this.props.genericBotData.SETTINGS, title: 'SETTINGS', parentArray: ['SETTINGS'], isGeneric: true}}
                                                    parent = {['OPTIONS']}
                                                />
                                            </div>
                                        </div>
                                        <div className = 'config-group-area'>
                                            <div className = 'config-inputs-wrapper'>
                                                {this.addInputType('OPTIONS',this.props.genericBotData.OPTIONS)}
                                            </div>
                                            <div className = 'icon-button-wrapper go-float-right'>
                                                <CreatePopMenu 
                                                    className = 'eb-icon-btn-style add-new-input'
                                                    parentArray = {['OPTIONS']}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.executeScroll()}
                            </div>
                        </div>
                    </>
                );
            default: 
                // console.log('default not added cases', genericParentKeys, this.props.currentGenericActiveTab)
        }
    }

    toggleModal = (currState = true) => {
        const { isOpen } = this.state;
        if(!currState) {
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            this.setState({isOpen: false});
        } else {
            document.getElementsByTagName('body')[0].style.overflow = isOpen ? 'auto' : 'hidden';
            this.setState(prevState => ({
                isOpen: !prevState.isOpen
            }),() => {
                if(this.state.isOpen && this.state.saveState !== 'save-err' && this.state.saveState !== 'generic-Save') {
                    setTimeout( () => {
                        this.setState({isOpen: false})
                    }, 2500000);
                }
            });
        }
    };

    onCancelCallback = () => {
        this.toggleModal();
    }

    onsubmitCallback = () => {
        this.toggleModal();
        if(this.props.genericBotData.hasOwnProperty('_id')) {
            delete this.props.genericBotData['_id']
        }
        this.setState({blockGenericUi: true})
        this.props.blockUiFun(true);
        this.props.saveGenericData(this.props.currentGenericLang, this.props.genericBotData, (data) => {
            // console.log('changes saved', data)
            this.setState({blockGenericUi: false})
            this.props.blockUiFun(false);
            this.setState({saveState: 'save-success'}, () => {this.toggleModal();})
        }, (err) => {
            this.setState({saveState: 'save-err', saveMessage: err}, () => {this.toggleModal();})
            this.props.blockUiFun(false);
            this.setState({blockGenericUi: false})
        })
    }

    renderContent = () => {
        let currentLangElm;
        if(this.props.currentGenericLang && this.state.slectedLangElm.code !== this.props.currentGenericLang) {
            currentLangElm = this.state.language.filter(elm => elm.code === this.props.currentGenericLang);
            this.setState({slectedLangElm: currentLangElm[0], blockGenericUi: false})
        }
        if(this.state.saveState === 'generic-Save') {
            return (
                // <div className = 'modal-body-content'>Please confirm to save the Generic {this.state.slectedLangElm.name} data</div>
                <div className = 'modal-body-content' style={{ textAlign: 'center', fontSize: '1rem' }}>Generic config of {this.state.slectedLangElm.name} language bots in this environment will get updated to reflect this changes.</div>
            );
        } else if(this.state.saveState === 'save-success') {
            return (
                <div className = 'modal-body-content' style = {{'text-align': 'center', 'padding': '25px', 'padding-bottom': 0, 'font-size': '16px', 'font-weight': 600}}>Generic Data Saved</div>
            );
        } else if(this.state.saveState === 'save-err') {
            return (
                <div className = 'modal-body-content' style={{ textAlign: 'center', fontSize: '1rem' }}>Generic Save Failed! <div className = 'content'>{this.state.saveMessage}</div></div>
            );
        } else {
            return <div>Done</div>
        }
    };

    render() {
        // const overlayClass = 'body-blocker-div' + (this.props.blockedUi ? ' active' : '');
        const overlayClass = 'body-blocker-div' + (this.props.blockedUi ? ' active' : '');
        const genricCheckFromUrl = this.props.location.pathname.split('/')[1];
        const tabFromUrl = this.props.location.pathname.split('/')[2];

        const { isOpen } = this.state;
        const header = {
            title: 'Confirmation Message',
            closeOnOutsideClick: this.state.saveState !== 'save-err' ? true : false,
            // isRemoveCloseIcon : true,  // send if needed to hide close icon on header
            style: this.state.saveState === 'generic-Save' ? {} : {
              // backgroundColor: 'red'
              display: 'none'
            }
        };
        const footer = {
            onSubmit: this.onsubmitCallback,
            onCancel: this.onCancelCallback,
            submitText: 'Confirm',
            cancelText: 'Cancel',
            customStyle: {
                // backgroundColor:'blue'
                justifyContent: 'flex-end'
            },
            disableSubmit: false,
            disableCancel: false
        };
        const footer2 = {
            onSubmit: this.onCancelCallback,
            submitText: 'Okay',
            customStyle: {
                // backgroundColor:'blue'
                justifyContent: 'flex-end'
            },
            disableSubmit: false,
            disableCancel: false
        };
        const customStyle = {
            maxWidth: '600px'
        };
        return (
            <div style={{ 'height': 'calc( 100vh - 65px )' }}>
                <ul className='nav nav-tabs bot-forge-nav' id='myTab' role='tablist'>
                    {
                        genricCheckFromUrl === 'genericconfig' && tabFromUrl && this.props.currentGenericActiveTab !== '' ? this.renderBotTabsTitle(tabFromUrl) : this.renderBotTabsTitle('')
                    }
                </ul>
                <div className={overlayClass}></div>
                <div className = 'tab-content bot-forge-tabs' id = 'botConfigTabs'>
                    {
                        this.props.genericBotData && Object.keys(this.props.genericBotData).length ? this.loadGnericBodyTabs() : null
                    }
                </div>

                <div className='float-icons-wrapper save-config-btn save-generic-config-btns'>
                    <ButtonV3
                        key='Cancel'
                        name='Cancel'
                        className='cancel-btn'
                        title='Reset Changes'
                        btnStyleType='secondary2'
                        onClick={
                            (e) => {
                                this.setState({blockGenericUi: true})
                                this.props.blockUiFun(true);
                                this.props.getGenericData(this.props.currentGenericLang, (res) => {
                                    this.setState({blockGenericUi: false})
                                    this.props.blockUiFun(false);
                                }, (err) => {
                                    console.log(err)
                                    this.setState({blockGenericUi: false})
                                    this.props.blockUiFun(false);
                                })
                            }
                        }
                    />
                    <ButtonV3
                        key='Save'
                        name='Save'
                        className='config-save-button'
                        title='Save Config'
                        btnstyle={{marginLeft: '1rem'}}
                        onClick={
                            (e) => {
                                this.setState({saveState: 'generic-Save'}, () => {this.toggleModal();})
                            }
                        }
                    />
                    <ButtonV3
                        key='Download Config'
                        name='Download Config'
                        className='config-download-button download-config-btn'
                        btnStyleType='secondary'
                        btnstyle={{marginLeft: '1rem'}}
                        onClick={
                            (e) => {
                                this.props.blockUiFun(true);
                                this.props.downloadGenericData(this.props.currentGenericLang, (res) => {
                                    console.log('Download Complete');
                                    this.props.blockUiFun(false);
                                }, (err) => {
                                    console.log('err', err);
                                    this.props.blockUiFun(false);
                                })
                            }
                        }
                    />
                </div>
                <div className = 'confirm-message-modal-container'>
                    <Modal
                        isOpen={isOpen}
                        onClose={() => {this.toggleModal(false)}}
                        header={header}
                        footer={this.state.saveState === 'generic-Save' ? footer : footer2}
                        customStyle={customStyle}
                    >
                        {this.renderContent()}
                    </Modal>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentGenericActiveTab: state.UiReducer && state.UiReducer.currentGenericActiveTab ? state.UiReducer.currentGenericActiveTab : '',
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {},
        highlightSearchedData: state.UiReducer && state.UiReducer.highlightSearchedData ? state.UiReducer.highlightSearchedData : {},
        currentLanguage: state.UiReducer && state.UiReducer.currentLanguage ? state.UiReducer.currentLanguage : 'en',
        blockedUi: state.UiReducer && state.UiReducer.blockedUi ? state.UiReducer.blockedUi : false,

        SIDE_MENU: state.UiReducer && state.UiReducer.SIDE_MENU ? state.UiReducer.SIDE_MENU : false,
        userName:  state.UiReducer && state.UiReducer.user && state.UiReducer.user.userName ? state.UiReducer.user.userName : 'Unknown',
        selectedBotId: state.UiReducer && state.UiReducer.selectedBotId ? state.UiReducer.selectedBotId : '',
        selectedBot: state.UiReducer && state.UiReducer.selectedBot ? state.UiReducer.selectedBot : 'Select Bot',
        isCustomBot: state.UiReducer && state.UiReducer.isCustomBot ? state.UiReducer.isCustomBot : false,
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : [],
        currentActiveTab: state.UiReducer && state.UiReducer.currentActiveTab ? state.UiReducer.currentActiveTab : '',
        currentGenericLang: state.UiReducer && state.UiReducer.currentGenericLang ? state.UiReducer.currentGenericLang : 'en'
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateCurrentGenericTabStatus,
        getGenericData,
        saveGenericData,
        downloadGenericData,
        blockUiFun,
        highlightSearchedResult    
    },
        dispatch
    );
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(GenericTab));
